var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClockFilter({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4997_38007)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 29,
    height: 29,
    rx: 3.5,
    stroke: "#12B6BC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 6C12.6131 6 10.3239 6.94821 8.63604 8.63604C6.94821 10.3239 6 12.6131 6 15H3L6.89 18.89L6.96 19.03L11 15H8C8 11.13 11.13 8 15 8C18.87 8 22 11.13 22 15C22 18.87 18.87 22 15 22C13.07 22 11.32 21.21 10.06 19.94L8.64 21.36C9.47341 22.198 10.4645 22.8627 11.5561 23.3158C12.6476 23.769 13.8181 24.0015 15 24C17.3869 24 19.6761 23.0518 21.364 21.364C23.0518 19.6761 24 17.3869 24 15C24 12.6131 23.0518 10.3239 21.364 8.63604C19.6761 6.94821 17.3869 6 15 6Z",
    fill: "#12B6BC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.82395 21.0999C11.2132 22.2787 12.9633 22.948 14.7846 22.9971C16.606 23.0462 18.3895 22.472 19.8402 21.3697C21.2909 20.2673 22.3218 18.7028 22.7625 16.9348C23.2032 15.1669 23.0271 13.3015 22.2635 11.6473C21.4999 9.99298 20.1945 8.64891 18.5632 7.83738C16.9319 7.02585 15.0725 6.79547 13.2925 7.18436C11.5124 7.57325 9.91848 8.55811 8.77426 9.97602C7.63004 11.3939 7.00411 13.16 7 14.982",
    stroke: "#12B6BC",
    strokeWidth: 2
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4997_38007"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClockFilter);
export default __webpack_public_path__ + "static/media/clock-filter.ed2916399bc6be16b3d85f2d611cf82a.svg";
export { ForwardRef as ReactComponent };